import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types, auth} from 'main/tools';
import {UserApiKey} from 'main/stores/users';

class ZapierConfigurationContainerState {
  store = new DomainStore();

  user;
  selectedUserApiKey = {};
  userApiKeys = [];
  displayApiKey = false;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.USER_API_KEYS.ALL
    ]);

    this.user = auth.user;
    this.userApiKeys = this.store._getAll(types.USER_API_KEY, UserApiKey);
  }

  async saveUserApiKey() {
    const {model, errors} = this.selectedUserApiKey.isNew ?
      await this.store.post(endpoints.USER_API_KEYS.ALL, types.USER_API_KEY, this.selectedUserApiKey) :
      await this.store.patch(this.selectedUserApiKey);

    if(model){
      if (!this.selectedUserApiKey.isNew) {
        this.closeEditUserApiKeyModal();
      } else {
        this.selectedUserApiKey = new UserApiKey(model);
        this.displayApiKey = true;
      }
      await this.load();
    }
    this.errors = errors;
  }

  async deleteUserApiKey(userApiKey) {
    await this.store.destroy(userApiKey);
    await this.load();
  }

  closeEditUserApiKeyModal() {
    this.displayApiKey = false;
  }
}

export default ZapierConfigurationContainerState;
